import React, { useEffect, createElement } from 'react';
import AdvertorialGlpInvestigationB from '../components/AdvertorialGlpInvestigationB';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpInvestigationBPage() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18550" data-mp="zv5k2p5folhv">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18551" data-mp="zumca19hzdhk">
        <Helmet data-id="element-18552" data-mp="zx8ju0we1szs">
          <title data-id="element-18553" data-mp="uvj6ufplv592">
            Why Are So Many People on GLP-1 Getting Depressed— And Why Won't
            Anyone Talk About It?
          </title>
          <meta property="og:title" content="Why Are So Many People on GLP-1 Getting Depressed—And Why Won't Anyone Talk About It?" data-id="element-18554" data-mp="qvs9ft5kpqvk" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18555" data-mp="2p7hi0n7h6b7l" />
          <meta property="og:type" content="article" data-id="element-18556" data-mp="bxg1uf2fbj51" />
          <meta property="og:url" content={window.location.href} data-id="element-18557" data-mp="gq0v9fhf3u81" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18558" data-mp="kruo51ldftxn" />
          <meta property="og:image:width" content="1200" data-id="element-18559" data-mp="3k8av6nrkwgtz" />
          <meta property="og:image:height" content="630" data-id="element-18560" data-mp="3p5sudmfsnhos" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18561" data-mp="3p6cf1awtwk6i" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18562" data-mp="3t6wb0b5o1hr2" />
          <meta name="twitter:title" content="Why Are So Many People on GLP-1 Getting Depressed—And Why Won't Anyone Talk About It?" data-id="element-18563" data-mp="21w7vy7f6uix" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18564" data-mp="18gngyp6p5lo1" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18565" data-mp="171b7em5tk3bs" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18566" data-mp="1kzstkfg2t7rl" />
        </Helmet>
        <AdvertorialGlpInvestigationB data-id="element-18567" data-mp="1gx5wo04jswnj" />
      </div>
    </HelmetProvider>;
}